interface RemoveColumnsFieldsConfig<TFields, TColumn> {
  columns: TColumn[];
  fields: Partial<Record<keyof TFields & string, boolean>>;
  key?: string;
}

export const removeColumnsFields = <TFields = Record<string, unknown>, TColumn = unknown>({
  columns,
  fields,
  key = 'field',
}: RemoveColumnsFieldsConfig<TFields, TColumn>): TColumn[] =>
  columns.filter((col) => {
    const value = (col as Record<string, unknown>)[key];
    return typeof value !== 'string' || !(fields as Record<string, boolean>)[value];
  });
